export default __webpack_public_path__ + "static/media/capitalFinance.d1b2302c.jpg";